import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/sns/telegram.png'
import _imports_1 from '@/assets/sns/discord.png'
import _imports_2 from '@/assets/board/delete_ico.png'


const _withScopeId = n => (_pushScopeId("data-v-60bd42b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layer" }
const _hoisted_2 = { class: "wrap" }
const _hoisted_3 = { class: "content_layer" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { id: "board_layer" }
const _hoisted_6 = { class: "board_top" }
const _hoisted_7 = { class: "board_top_btns" }
const _hoisted_8 = { class: "count" }
const _hoisted_9 = { class: "board_list" }
const _hoisted_10 = { class: "board_table" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("colgroup", null, [
  /*#__PURE__*/_createElementVNode("col", { width: "3%" }),
  /*#__PURE__*/_createElementVNode("col", { width: "4%" }),
  /*#__PURE__*/_createElementVNode("col", { width: "auto" }),
  /*#__PURE__*/_createElementVNode("col", { width: "auto" }),
  /*#__PURE__*/_createElementVNode("col", { width: "auto" }),
  /*#__PURE__*/_createElementVNode("col", { width: "auto" }),
  /*#__PURE__*/_createElementVNode("col", { width: "auto" }),
  /*#__PURE__*/_createElementVNode("col", { width: "auto" }),
  /*#__PURE__*/_createElementVNode("col", { width: "4%" })
], -1))
const _hoisted_12 = { class: "chk" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "연번", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "검색키워드", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "검색 플랫폼", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "검색일시", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "구분", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "진행상황", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "검색결과", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "삭제", -1))
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "chk" }
const _hoisted_24 = ["value"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "pop_sns_box" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = { key: 1 }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { class: "search_txt_box" }
const _hoisted_36 = { class: "total_count" }
const _hoisted_37 = {
  type: "button",
  class: "delete_btn"
}
const _hoisted_38 = ["onClick"]
const _hoisted_39 = { key: 1 }
const _hoisted_40 = { colspan: "14" }
const _hoisted_41 = { key: 2 }
const _hoisted_42 = { colspan: "14" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_NoResult = _resolveComponent("NoResult")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_PageBtn = _resolveComponent("PageBtn")!
  const _component_Popup = _resolveComponent("Popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Header),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "board_btn",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.deleteLists && $setup.deleteLists(...args)))
                  }, "선택삭제")
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createTextVNode(" 총 "),
                  _createElementVNode("span", null, _toDisplayString($setup.numberFormat($setup.state.totalLength)) + "건", 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("table", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, [
                        _createElementVNode("label", _hoisted_12, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.state.isCheckAll) = $event)),
                            onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.toggleAll && $setup.toggleAll(...args)))
                          }, null, 544), [
                            [_vModelCheckbox, $setup.state.isCheckAll]
                          ]),
                          _hoisted_13
                        ])
                      ]),
                      _hoisted_14,
                      _hoisted_15,
                      _hoisted_16,
                      _hoisted_17,
                      _hoisted_18,
                      _hoisted_19,
                      _hoisted_20,
                      _hoisted_21
                    ])
                  ]),
                  (!$setup.state.isLoading)
                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_22, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list.data, (item, idx) => {
                          return (_openBlock(), _createElementBlock("tr", null, [
                            _createElementVNode("td", null, [
                              _createElementVNode("label", _hoisted_23, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.state.checkList) = $event)),
                                  value: item.idx
                                }, null, 8, _hoisted_24), [
                                  [_vModelCheckbox, $setup.state.checkList]
                                ]),
                                _hoisted_25
                              ])
                            ]),
                            _createElementVNode("td", null, _toDisplayString(item.idx), 1),
                            _createElementVNode("td", null, [
                              _createElementVNode("span", {
                                class: _normalizeClass(item.keyword.length > 12 ? 'more_txt' : ''),
                                onClick: ($event: any) => ($setup.moreText(item.keyword))
                              }, _toDisplayString(item.keyword), 11, _hoisted_26)
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("div", _hoisted_27, [
                                (item.telegram === 1)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_28, _hoisted_30))
                                  : _createCommentVNode("", true),
                                (item.discord === 1)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_31, _hoisted_33))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("td", null, _toDisplayString($setup.formatDate(item.createDate)), 1),
                            _createElementVNode("td", null, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "blue_btn",
                                onClick: ($event: any) => ($setup.resultBtn(item.idx))
                              }, "검색결과", 8, _hoisted_34)
                            ]),
                            _createElementVNode("td", null, [
                              (item.state === 0)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode("대기중")
                                  ], 64))
                                : (item.state === 1)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createTextVNode("검색중")
                                    ], 64))
                                  : (item.state === 2)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                        _createTextVNode("완료")
                                      ], 64))
                                    : (item.state === 3)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                          _createTextVNode("결과 없음")
                                        ], 64))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                          _createTextVNode("에러 : " + _toDisplayString(item.error), 1)
                                        ], 64))
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("div", _hoisted_35, [
                                _createElementVNode("span", _hoisted_36, " 총 " + _toDisplayString(item.cntResult ? $setup.numberFormat(item.cntResult) : 0) + " 건 ", 1)
                              ])
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("button", _hoisted_37, [
                                _createElementVNode("img", {
                                  src: _imports_2,
                                  alt: "",
                                  onClick: ($event: any) => ($setup.deleteList(item.idx))
                                }, null, 8, _hoisted_38)
                              ])
                            ])
                          ]))
                        }), 256))
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.list.data.length === 0 && !$setup.state.isLoading)
                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_39, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", _hoisted_40, [
                            _createVNode(_component_NoResult)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.state.isLoading)
                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_41, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", _hoisted_42, [
                            _createVNode(_component_Spinner)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              ($setup.list.data.length !== 0 && !$setup.state.isLoading)
                ? (_openBlock(), _createBlock(_component_PageBtn, {
                    key: 0,
                    currentPage: $setup.state.currentPage,
                    totalLength: $setup.state.totalLength,
                    perPage: $setup.state.perPage,
                    onOnPaging: $setup.handlePageChange
                  }, null, 8, ["currentPage", "totalLength", "perPage", "onOnPaging"]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Popup, {
      show: $setup.state.isModalOpen,
      title: $setup.modal.title,
      content: $setup.modal.content,
      onClose: $setup.modalClose
    }, null, 8, ["show", "title", "content", "onClose"])
  ], 64))
}